export enum SkillId {
  DISCOUNT = "discount",
}
